import React from 'react';

const Tooltip = ({ text, children }) => {
    const styles = {
        wrapper: {
            position: 'relative',
            display: 'inline-block',
            cursor: 'pointer',
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
    },
    tooltip: {
        visibility: 'hidden',
        backgroundColor: '#333',
        color: '#fff',
        textAlign: 'center',
        borderRadius: '4px',
        padding: '5px 8px',
        position: 'absolute',
        zIndex: 100,
        bottom: '125%',
        left: '50%',
        transform: 'translateX(-50%)',
        whiteSpace: 'nowrap',
        fontSize: '12px',
        opacity: 0,
        transition: 'opacity 0.3s',
    },
    wrapperHover: {
        visibility: 'visible',
        opacity: 1,
    }
    };

return (
    <div
        style={styles.wrapper}
        onMouseEnter={(e) => {
            const tooltip = e.currentTarget.querySelector('.tooltip');
            tooltip.style.visibility = 'visible';
            tooltip.style.opacity = '1';
        }}
        onMouseLeave={(e) => {
            const tooltip = e.currentTarget.querySelector('.tooltip');
            tooltip.style.visibility = 'hidden';
            tooltip.style.opacity = '0';
        }}
    >
        {children}
        <div className="tooltip" style={styles.tooltip}>{text}</div>
    </div>
);
};

export default Tooltip;
